import React, { ReactNode } from "react";
import styled from "styled-components";

export interface FilterChipListProps
  extends React.HTMLAttributes<HTMLLIElement> {
  title: string;
  children: ReactNode;
}

const FilterListItem = ({ title, children, ...args }: FilterChipListProps) => {
  return (
    <FilterListLayout {...args}>
      <h2>{title}</h2>
      <div>{children}</div>
    </FilterListLayout>
  );
};

export default FilterListItem;

export const FilterListLayout = styled.li`
  display: flex;
  align-items: center;
  gap: 5rem;

  h2 {
    min-width: 10rem;
    ${({ theme }) => theme.typography.body1.semibold};
    color: ${({ theme }) => theme.color.text.secondary};
  }

  & > div {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    align-items: center;
    width: 100%;
  }
`;
